const Flights = require('od-apps/app.flights');
const Accommodations = require('od-apps/app.accommodations');
const {addTabMetadata} = require('od-modules/utils/tab_manager/tab_status');
let DP = {};
const ACCOMMODATION_PARAMS = ['dedupId', 'providerHotelId', 'providerId'];

DP.isAccommodationResults = Flights.isAccommodationResults;

DP.isAmendProductPages = function(currentPage) {
    return /^(dpresults_flights|dpresults_accommodation_details)$/.test(currentPage);
};

DP.getSearchData = function(params, page) {
    return Flights.getSearchData(params, page, DP.searchParamsParser)
        .then((searchData) => searchData.rooms !== undefined ? Promise.resolve(searchData) : Promise.reject({}));
};

DP.searchParamsStringify = function(params, keyParams) {
    var accSearchParams = Accommodations.searchParamsStringify(params);
    var flightSearchParams = Flights.searchParamsStringify(Odigeo._.extend({}, params, accSearchParams.updatedParamObj), keyParams);
    var dynpackSearchParams = [flightSearchParams, accSearchParams.stringifiedParams];
    var separator = _(dynpackSearchParams).compact().size() > 0 ? ';' : '';

    return dynpackSearchParams.join(separator);
};

DP.searchParamsParser = function(p) {
    return $.extend(true, Flights.searchParamsParser(p), Accommodations.searchParamsParser(p));
};

DP.convertRequest = function(request) {
    var hasData = Odigeo._.isObject(request) && Odigeo._.has(request, 'type') && request.type;
    var data = !hasData ? request : Odigeo._.extend({}, request, {
        cabinClass: 'TOURIST',
        directFlightsOnly: false,
    });
    var isForceNewSearch = function() {
        var reqFromHome = Odigeo.Session.get('dpForceNewSearch');
        Odigeo.Session.remove('dpForceNewSearch');
        var isSameDedupId = true;

        if (Odigeo.Utils.isMobile() && Odigeo._.get(Odigeo.Utils.decodeParams(window.location.search.substring(1)), 'mktportal')) {
            var previousSearch = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            if (!previousSearch) {
                return true;
            }
            var previousExternalSelectionRequest = previousSearch.externalSelectionRequest;
            if (request.externalSelectionRequest && previousExternalSelectionRequest) {
                isSameDedupId = previousExternalSelectionRequest.dedupId == request.externalSelectionRequest.dedupId;
            }
        }

        return (!Odigeo._.isNull(reqFromHome) && Boolean(reqFromHome)) || !isSameDedupId;
    };
    var newData = data;

    if (hasData) {
        var segmentsInfo = getInfoFromSegmentsRequest(data.searchSegments);
        newData = {
            dynPackSearchRequest: {
                oneWaySegmentRequest: segmentsInfo.segmentRequests[0],
                returnSegmentRequest: segmentsInfo.segmentRequests[1],
                departure: segmentsInfo.departure,
                destination: segmentsInfo.destination,
                itineraryDestination: getItineraryDestination(segmentsInfo.destination),
                cabinClass: data.cabinClass,
                directFlightsOnly: data.directFlightsOnly,
                resident: false,
                itinerarySearchMainProductType: 'FLIGHT',
                excludedCarriers: data.airlinesCodes || [],
                accommodationCheckInDate: data.checkInDate || segmentsInfo.segmentRequests[0].date,
                accommodationCheckOutDate: data.checkOutDate || segmentsInfo.segmentRequests[1].date,
                roomRequests: convertRoomRequest(data.rooms),
                externalSelectionRequest: Odigeo._.extend({}, data.externalSelectionRequest, {
                    landingPageType: data.landingPageType,
                    priceWithoutDiscountSelected: Odigeo.Utils.parseJson(Odigeo.Session.get('isDpNonPrimePriceSelected')),
                }),
            },
            buyPath: data.buyPath,
            collectionMethod: data.collectionMethod,
            forceNewSearch: isForceNewSearch(),
        };
        // We extend the DP request with a Flight's request so that ItinerarySearchRequest will be filled with
        // necessary information for the flight's part of DP.
        newData = $.extend(true, {}, Flights.convertRequest(data), newData, getNumberOfPaxFlightsRequest(data));
    }
    return newData;
};

DP.hasToRedirectFromSecure = () =>
    Odigeo._.isNull(Odigeo.Session.get('searchParameters'))
    && document.location.hash.indexOf('redirect=dpresults') !== -1;

DP.isPreparedToLaunchSearchInSecure = () =>
    Odigeo._.isNull(Odigeo.Session.get('searchParameters'))
    && new URLSearchParams(document.location.search).has('flowProduct');

var getItineraryDestination = function(destSegment) {
    return destSegment && destSegment.iata ? {iata: destSegment.iata} : null;
};

// If the number of pax doesn't match between flights & accommodations, we return an invalid # of pax so that
// dpsearchmanager doesn't throw the dp search.
var getNumberOfPaxFlightsRequest = function(requestInfo) {
    var paxInfoBasedOnRooms = getPaxInfoBasedOnRooms(requestInfo.rooms);

    return Odigeo._.isEqual(paxInfoBasedOnRooms, Odigeo._.pick(requestInfo, 'numAdults', 'numChildren', 'numInfants')) ?
        {} : {itinerarySearchRequest: {numAdults: -1, numChildren: -1, numInfants: -1}};
};

var getPaxInfoBasedOnRooms = function(rooms) {
    return Odigeo._.reduce(rooms, function(memo, val) {
        Accommodations.updatePassengersNum(memo, [val.numAdults, val.kidsAges.length, val.infantsAges.length]);
        return memo;
    }, {});
};

var convertRoomRequest = function(rooms) {
    return Odigeo._.reduce(rooms, function(memo, val) {
        val.childrenAges = val.kidsAges.concat(val.infantsAges);
        return memo.concat(Odigeo._.pick(val, 'numAdults', 'childrenAges'));
    }, []);
};

var getInfoFromSegmentsRequest = function(segments) {
    var departure = '';
    var destination = '';
    var segmentRequests = Odigeo._.reduce(segments, function(memo, segment) {
        departure = departure || segment.departure;
        destination = destination || segment.destination;
        return memo.concat({
            date: segment.dateStr,
        });
    }, []);

    return {
        segmentRequests: segmentRequests,
        departure: departure,
        destination: destination,
    };
};

var getDeeplink = function(extendedSearchParameters) {
    var searchParams = Odigeo._.extend({},
        Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')),
        extendedSearchParameters
    );
    var extendKeyParams = ['segmentKey0', 'segmentKey1', 'fareItineraryKey'];

    return DP.searchParamsStringify(searchParams, Odigeo._.zipObject(extendKeyParams, extendKeyParams));
};

DP.getBuyPath = function(page) {
    return {
        dpresults: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        dpresults_accommodation: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        roomselection: 'DYNPACK_EXPIRED_ROOMSELECTION_POPUP',
        dpresults_accommodation_details: 'DYNPACK_EXPIRED_ROOMSELECTION_POPUP',
        dpresults_flights: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        booking: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        passengersinfo: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        details: 'DYNPACK_EXPIRED_SEARCH_POPUP',
        payment: 'DYNPACK_EXPIRED_SEARCH_POPUP',
    }[page] || 'UNKNOWN';
};

DP.getHomeBuyPath = function(isDynpackHome, isDynpackTabActive) {
    const homeType = isDynpackHome ? 'DYNPACK' : 'FLIGHTS';
    return isDynpackTabActive ? `${homeType}_HOME_DYNPACK_TAB` : `${homeType}_HOME_FLIGHTS_TAB`;
};

DP.setMobileBuyPath = function() {
    var getHomeBuyPath = function() {
        return Odigeo.Utils.isRequestApp('dp') ? 'DYNPACK_MOBILE_HOME' : 'DYNPACK_MOBILE_FLIGHTS_TAB';
    };
    var buyPathsByMobilePage = {
        '': getHomeBuyPath(),
        'home': getHomeBuyPath(),
        'dpresults_flights': 'DYNPACK_MOBILE_RESULTS_CHANGE_SEARCH',
        'dpresults_accommodation': 'DYNPACK_MOBILE_ACCOMMODATION_CHANGE_SEARCH',
        'booking': 'DYNPACK_MOBILE_BOOKING_CHANGE_SEARCH',
    };

    var pageName = Odigeo.History.getPageNameFromFragment();
    var mobileBuyPath = buyPathsByMobilePage[pageName] || '';
    Odigeo.Session.set('mobileBuyPath', mobileBuyPath);
    return mobileBuyPath;
};

DP.purgeExpiredSearch = function(search) {
    var today = Odigeo.Utils.getToday();
    var checkSearch = function(search) {
        var date;
        return Odigeo._.size(search.searchSegments) > 0 &&
            Odigeo._.isDate(date = Odigeo.Utils.parseDate(search.searchSegments[0].dateStr)) &&
            date.getTime() >= today;
    };

    return !Odigeo._.isEmpty(search) && checkSearch(search) ? search : null;
};

DP.getDeeplinkWithShoppingCart = function(cart) {
    return getDeeplink(Odigeo._.pick({
        dedupId: cart.accommodation.dedupId,
        providerHotelId: cart.accommodation.providerHotelId,
        providerId: cart.accommodation.providerId,
        fareItineraryKey: cart.fareItinerary.id,
        segmentKey0: cart.fareItinerary.outboundFlight,
        segmentKey1: cart.fareItinerary.returnFlight,
        roomsId: cart.roomsId,
    }, Odigeo._.identity));
};
DP.getDeeplinkWithoutShoppingCart = getDeeplink;

DP.getDeeplinkWithPreselected = function(preselected) {
    return getDeeplink(Odigeo._.pick({
        dedupId: preselected.accommodation.dedupId,
        providerHotelId: preselected.accommodation.providerHotelId,
        providerId: preselected.accommodation.providerId,
        fareItineraryKey: preselected.fareItinerary.id,
        segmentKey0: preselected.fareItinerary.outboundFlight,
        segmentKey1: preselected.fareItinerary.returnFlight,
        roomsId: preselected.roomsId,
    }, Odigeo._.identity));
};

DP.getDeeplinkWithoutPreselected = getDeeplink;

DP.getPath = function(options) {
    return Odigeo.Utils.templateLiteral('${protocol}//${host}${path}/dp/${pageParams}#${page}/${searchParams}${tabProduct}', {
        protocol: window.location.protocol,
        host: window.location.hostname,
        path: Odigeo.Settings.getProperty('appContext'),
        pageParams: Odigeo._.isString(options.pageParams) ? '?' + options.pageParams : '',
        page: options.page || Odigeo.History.getPageNameFromFragment(),
        searchParams: options.searchParams,
        tabProduct: Odigeo._.isString(options.tabProduct) ? options.tabProduct : '',
    });
};

DP.getLabelTrackRooms = (searchParams) => Odigeo._.reduce(searchParams.rooms,
    (label, room, index) => label.concat(
        `_num:${index + 1}` +
        `_adu:${room.numAdults}` +
        `_child:${Odigeo._.size(room.kidsAges)}` +
        `_baby:${Odigeo._.size(room.infantsAges)}`)
    , `rooms:${searchParams.numberOfRooms}`);

const cleanAccommodationParams = (url) => Odigeo._.reduce(ACCOMMODATION_PARAMS,
    (parsedUrl, param) => parsedUrl.replace(new RegExp(`;${param}=[^;]+;*`), ''), url);

DP.openHotelPageTab = ({dedupId, providerHotelId, providerId, key}, hotelPosition) => {
    const dpresultsNavigation = require('od-modules/handlers/dpresults/navigation');
    const tabName = Object.values({dedupId, providerHotelId, providerId}).filter(Boolean).join('');
    const accommodationParams = `providerId=${providerId};providerHotelId=${providerHotelId};dedupId=${dedupId}`;
    const url = cleanAccommodationParams(dpresultsNavigation.getNextUrl());
    const hotelPage = window.open(`#${url};${accommodationParams}`, tabName);

    addTabMetadata(hotelPage, {hotelPosition, tabName, key});
    hotelPage.focus();
};

DP.accommodationSelectedByDeepLink = () => {
    const dpData = Odigeo.Session.get('dynpackDeeplink') || window.location.hash;
    let accommodationSelected;
    if (dpData) {
        const regex = /.*providerId=(.*?);.*providerHotelId=(.*?);.*/;
        const dedupIdRegex = /.*dedupid=(.*?);.*/;

        const [, providerId, providerHotelId] = dpData.match(regex);

        const dedupData = dpData.match(dedupIdRegex);
        const [, dedupId] = dedupData ? dedupData : dpData.split('dedupId=');
        accommodationSelected = {providerId, providerHotelId, dedupId};
    } else {
        accommodationSelected = {providerId: null, providerHotelId: null, dedupId: null};
    }
    return accommodationSelected;
};

DP.setNonPrimeFlowIfMetas = () => {
    if (Odigeo.SessionScope.isMeta
        && (Odigeo._.isUndefined(Odigeo.Session.get('isDpNonPrimePriceSelected'))
            || Odigeo._.isNull(Odigeo.Session.get('isDpNonPrimePriceSelected')))) {
        Odigeo.Session.set('isDpNonPrimePriceSelected', true);
    }
};

DP.redirectToOF2Page = (options) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.pathname = '/travel/dynpack/';
    url.searchParams.set('flowProduct', 'dp');
    const newHash = options.bookingId ? `${options.newPage}/${options.bookingId}/` : options.newPage;
    url.hash = newHash;
    window.location.assign(url.toString());
};

module.exports = DP;
